import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-718bd202"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"min-width":"120px"} }
const _hoisted_3 = { style: {"margin-top":"20px"} }
const _hoisted_4 = {
  class: "charts-section",
  style: {"margin-top":"20px"}
}
const _hoisted_5 = {
  ref: "dayChartRef",
  class: "chart-container"
}
const _hoisted_6 = {
  ref: "monthChartRef",
  class: "chart-container"
}
const _hoisted_7 = {
  ref: "gmtChartRef",
  class: "chart-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState,
        ref: "searchFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "adsId",
            label: "广告账户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.adsId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.adsId) = $event)),
                placeholder: "请输入广告账户ID",
                style: {"width":"200px"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "dateRange",
            label: "日期区间"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: $setup.searchFormState.dateRange,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.dateRange) = $event)),
                valueFormat: $setup.dateFormat,
                placeholder: ['开始日期', '结束日期'],
                ranges: $setup.dateRanges,
                allowClear: ""
              }, null, 8, ["value", "valueFormat", "ranges"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "userId",
            label: "用户ID"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_UserSelect, {
                  modelValue: $setup.searchFormState.userId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.userId) = $event)),
                  placeholder: "请选择用户",
                  allowAll: true
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          ($setup.getUserRoleType() === 0)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                name: "userType",
                label: "用户类型"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: $setup.searchFormState.userType,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchFormState.userType) = $event)),
                    placeholder: "请选择用户类型",
                    style: {"width":"120px"},
                    allowClear: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("外部")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("内部")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($setup.getUserRoleType() === 0)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                name: "createBy",
                label: "创建者(户)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: $setup.searchFormState.createBy,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($setup.searchFormState.createBy) = $event)),
                    placeholder: "请选择或搜索创建者(户)",
                    "show-search": "",
                    "filter-option": false,
                    onSearch: $setup.handleCreatorFilterSearch,
                    onPopupScroll: $setup.handleCreatorFilterScroll,
                    onFocus: $setup.handleCreatorFilterFocus,
                    onClear: $setup.handleCreatorFilterClear,
                    loading: $setup.creatorFilterLoading,
                    "option-label-prop": "label",
                    "allow-clear": "",
                    style: {"min-width":"260px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.creatorFilterList, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item.id,
                          value: item.id,
                          label: item.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onSearch", "onPopupScroll", "onFocus", "onClear", "loading"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: $setup.getUserRoleType() === 0 ? 1320 : 1200 },
        rowClassName: $setup.getRowClassName
      }, {
        totalExpend: _withCtx(({ scope }) => [
          _createElementVNode("span", null, "$" + _toDisplayString((scope.record.totalExpend || 0).toFixed(2)), 1)
        ]),
        createBy: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString(scope.record.createByName), 1)
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading", "scroll", "rowClassName"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        pageSize: $setup.pageSize,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        "show-size-changer": "",
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "pageSize", "onShowSizeChange"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_a_card, { bordered: true }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: $setup.activeTabKey,
            "onUpdate:activeKey": _cache[6] || (_cache[6] = ($event: any) => (($setup.activeTabKey) = $event)),
            onChange: $setup.handleTabChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "day",
                tab: "近15天统计"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, null, 512)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "month",
                tab: "近12月统计"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, null, 512)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "gmt",
                tab: "时区统计"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, null, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey", "onChange"])
        ]),
        _: 1
      })
    ])
  ], 64))
}